import React from 'react'
import { Persona, PersonaInitialsColor } from '@fluentui/react';

class LoggedUser extends React.Component {

    render() {
        //console.log(this.props.user);
        return (
            <div>
                <Persona
                    styles={{
                        primaryText: {
                            color: 'white !important',
                            fontSize: '16px',
                            lineHeight: '25px'
                        },
                        secondaryText: {
                            color: 'white',
                            lineHeight: '10px'
                        }
                    }}
                    size={12}
                    initialsColor={PersonaInitialsColor.cyan}
                    text={this.props.user.displayName}
                    secondaryText={this.props.user.role !== 'None' ? this.props.user.role : ""} />
            </div>
        )
    }
}


export default LoggedUser


// WEBPACK FOOTER //
// ./src/components/Navigation/LoggedUser.js